import { Injectable } from '@angular/core';

@Injectable()
export class WebUserService {

  constructor() { }
  public userId: string = '';
  public headerMemberStatus:boolean=false;

  updateUser(newValue): void {
    this.userId = newValue;
  }

  getUserId(): string {
    return this.userId;
  }

  updateHeaderMemberStatus():void{
    this.headerMemberStatus=false;
  }
  
  getHeaderMemberStatus():boolean{
    return this.headerMemberStatus;
  }

}
